import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * The "there is nothing to show" state, in one place.
 *
 * Without this, an empty table renders as a header row over blank space, which
 * reads as a failed load rather than an empty list. Every list screen should
 * be able to say what is missing and what to do about it.
 */
export const EmptyState: React.FC<{
  title: string;
  description?: string;
  action?: React.ReactNode;
  icon?: React.ReactNode;
}> = ({ title, description, action, icon }) => (
  <Stack alignItems="center" spacing={1.5} sx={{ py: { xs: 5, md: 8 }, px: 3 }}>
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'action.hover',
        color: 'text.secondary',
      }}
    >
      {icon ?? <InboxOutlinedIcon />}
    </Box>
    <Typography variant="subtitle1" align="center">
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        color="text.secondary"
        align="center"
        sx={{ maxWidth: 380 }}
      >
        {description}
      </Typography>
    )}
    {action && <Box sx={{ pt: 1 }}>{action}</Box>}
  </Stack>
);
